<script setup lang="ts">
import type { FlightProcessingBucket } from "@ca/types/flights";

import { computed } from "vue";

import { FLIGHT_SEGMENTS } from "@/utils/flightProgress";

const props = withDefaults(defineProps<{
	bucket: FlightProcessingBucket;
	size?: "sm" | "md";
}>(), { size: "md" });

const segment = computed(() =>
	FLIGHT_SEGMENTS.find(entry => entry.key === props.bucket) ?? null);
</script>

<template>
  <UTooltip
    :text="segment?.label ?? ''"
    :delay-duration="0"
  >
    <span
      class="inline-flex items-center bg-brand-500 py-1 rounded-sm w-fit"
      :class="size === 'sm' ? 'gap-1.5 px-2 text-xs leading-4' : 'gap-2 px-3'"
    >
      <span
        :class="[segment?.class, size === 'sm' ? 'size-1' : 'size-1.5']"
        class="rounded-full animate-pulse"
      />
      <span class="uppercase text-white font-cta">
        Flight Processing
      </span>
    </span>
  </UTooltip>
</template>
